"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingInsights = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("../../../../../../../shared/core");
var copy_1 = require("../../../../../copy");
var StyledIcon = styled_components_1.default.svg(function (_a) {
    var colors = _a.theme.colors, status = _a.status;
    return "\n    color: ".concat(colors[status], ";\n  ");
});
var Status = function (_a) {
    var status = _a.status;
    var Icon = (0, core_1.useComponents)().Icon;
    return status === 'success' ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledIcon, { status: status, as: Icon, name: "check" }),
        ' ')) : status === 'error' ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledIcon, { status: status, as: Icon, name: "cross" }),
        ' ')) : status === 'warning' ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledIcon, { status: status, as: Icon, name: "warning" }),
        ' ')) : null;
};
var BillingInsights = (0, react_1.forwardRef)(function (_a, ref) {
    var insights = _a.insights, rest = __rest(_a, ["insights"]);
    var _b = (0, core_1.useComponents)(), Dl = _b.Dl, Dt = _b.Dt, Dd = _b.Dd;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    if (!insights.length) {
        return null;
    }
    return (react_1.default.createElement(Dl, __assign({ "data-testid": "billing-insights" }, rest, { ref: ref }),
        react_1.default.createElement(Dt, null,
            react_1.default.createElement(Copy, { copyKey: "billingInsightsLabel" })),
        insights.map(function (_a, index) {
            var label = _a.label, status = _a.status;
            return (react_1.default.createElement(Dd, { key: "billing-insight-".concat(index), "data-testid": "billing-insight" },
                react_1.default.createElement(Status, { status: status }),
                label));
        })));
});
exports.BillingInsights = BillingInsights;
